/* Raine & Co legal pages (legal information, PAIA manual, policy pages) and refer a friend: contents list with the
   section in view marked, form checks before Shopify sends a request, cookie settings and copy buttons. */
(function () {
  'use strict';
  var D = document, W = window;
  var $ = function (s, r) { return (r || D).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); };
  var phone = W.matchMedia('(max-width:900px)').matches;

  /* ---------- forms built from .field rows (PAIA request, referral link) ---------- */
  $$('form[data-check]').forEach(function (f) {
    if (!f.querySelector('.field')) return;
    f.setAttribute('novalidate', '');
    f.addEventListener('submit', function (e) {
      var bad = null;
      $$('[required]', f).forEach(function (el) {
        var wrap = el.closest('.field');
        var ok = el.type === 'checkbox' ? el.checked : (el.type === 'email' ? /\S+@\S+\.\S+/.test(el.value) : String(el.value).trim() !== '');
        if (wrap) wrap.classList.toggle('err', !ok);
        if (!ok && !bad) bad = el;
      });
      if (bad) { e.preventDefault(); bad.focus(); }
    });
    $$('input, select, textarea', f).forEach(function (el) {
      el.addEventListener('input', function () { var w = el.closest('.field'); if (w) w.classList.remove('err'); });
    });
  });
  var done = $('form .done');
  if (done) { done.focus(); done.scrollIntoView({ block: 'center' }); }

  /* ---------- copy buttons ---------- */
  $$('[data-copy]').forEach(function (b) {
    b.addEventListener('click', function () {
      var t = $(b.getAttribute('data-copy')); if (!t) return;
      var txt = t.textContent, lbl = b.textContent;
      var ok = function () { b.textContent = 'Copied'; setTimeout(function () { b.textContent = lbl; }, 1800); };
      var sel = function () { var r = D.createRange(); r.selectNodeContents(t); var s = W.getSelection(); s.removeAllRanges(); s.addRange(r); };
      try { navigator.clipboard.writeText(txt).then(ok, sel); } catch (e) { sel(); }
    });
  });

  /* cookie settings buttons ([data-cookie-settings]) are handled by theme.js */

  /* ---------- contents list ---------- */
  var links = $$('.toc a[href^="#"]');
  if (!links.length) return;
  var td = $('.toc details'); if (td && phone) td.open = false;
  links.forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = D.getElementById(a.getAttribute('href').slice(1)); if (!t) return;
      e.preventDefault();
      var reduce = W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches;
      t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      t.setAttribute('tabindex', '-1'); t.focus({ preventScroll: true });
      var det = a.closest('details'); if (det && phone) det.open = false;
    });
  });
  if (!('IntersectionObserver' in W)) return;
  var map = {};
  links.forEach(function (a) { map[a.getAttribute('href').slice(1)] = a; });
  var io = new IntersectionObserver(function (en) {
    en.forEach(function (x) {
      if (!x.isIntersecting) return;
      links.forEach(function (a) { a.removeAttribute('aria-current'); });
      var a = map[x.target.id]; if (a) a.setAttribute('aria-current', 'true');
    });
  }, { rootMargin: '-30% 0px -60% 0px' });
  $$('.prose>section[id]').forEach(function (s) { io.observe(s); });
})();
